import {useQuery} from "react-query"
import useAuth from "auth/useAuth"
import {setLocalItem} from "utils/utils"


export default function useShifts() {

    const {auth, API} = useAuth()
    const key = 'shifts'
    
    const preload = () => {
        const data = localStorage.getItem(key)
        if (!data) return {}
        return JSON.parse(data)
    }
    
    const fetched = (data) => {
        setLocalItem(key, data)
    }
    
    const query = useQuery(key,
        () => {
            return auth(API.shiftsGet).then(response => Object.assign({}, ...response.data.map(shift => ({[shift.area]: shift}))))
        },
        {initialData: preload, onSuccess: fetched}
    )
    
    
    const get = (area) => {
        if (!query.data) return {}
        return query.data[area] ?? {}
    }
    
    const getRescuers = (area) => {
        const shift = get(area)
        let shiftRescuers = []
        if (shift.head) shiftRescuers.push(shift.head)
        if (shift.rescuers) shiftRescuers = [...shiftRescuers, ...shift.rescuers]
        return shiftRescuers
    }
    
    
    return {...query, get, getRescuers}
    
}